// brain kitchen — main JS
(function () {
  'use strict';

  // ── NAV scroll behavior
  const nav = document.getElementById('nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('on', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Hero bg loaded animation
  const heroBg = document.getElementById('heroBg');
  if (heroBg) {
    const src = heroBg.style.backgroundImage.replace(/url\(['"]?/, '').replace(/['"]?\)$/, '');
    if (src) {
      const tmp = new Image();
      tmp.onload = () => heroBg.classList.add('on');
      tmp.src = src;
    }
  }

  // ── Scroll reveal
  const revealEls = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window && revealEls.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('on');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -28px 0px' });
    revealEls.forEach(el => obs.observe(el));
  } else {
    // Fallback: show all immediately
    revealEls.forEach(el => el.classList.add('on'));
  }

  // ── Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        const navH = nav ? nav.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - navH;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // ── Contact form: prevent double submit
  const form = document.getElementById('ContactForm');
  if (form) {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('.form-sub');
      if (btn) {
        btn.disabled = true;
        btn.textContent = '送信中...';
      }
    });
  }

})();
